import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { IOption, Select } from 'components/Select';
import { useTranslation } from 'react-i18next';
import { SETTINGS_PAGE_OPTIONS } from './constants';
import { INotificationProps } from './LanguageComponent';

export const PageSizeComponent = ({
  dealerSettings,
  handleChange,
}: INotificationProps) => {
  const { t } = useTranslation();

  const handlePageChange = async (option: IOption) => {
    handleChange({ ...dealerSettings, pageSize: +option.value });
  };

  return (
    <>
      <Row className="align-items-center">
        {' '}
        <Col md={3}>
          <h6 className="h6-short">
            {t('dealerManagement.settings.pageSize')}
          </h6>
        </Col>
        <Col md={9}>
          <Select
            options={SETTINGS_PAGE_OPTIONS}
            onChange={handlePageChange}
            value={
              dealerSettings.pageSize &&
              SETTINGS_PAGE_OPTIONS.find(
                (opt) => opt.value === dealerSettings.pageSize
              )
            }
          />
        </Col>
      </Row>
    </>
  );
};
